import { Box, Stack } from "@mui/material";
import { type SxProps } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { TopLeftBackButton } from "@src/appV2/redesign/components/TopLeftBackButton";
import { Text } from "@src/appV2/redesign/system/ui-components";

interface ConfirmStepProps {
  onConfirm: () => void;
  onBack: () => void;
  sx?: SxProps;
}

export function ConfirmStep(props: ConfirmStepProps) {
  const { onConfirm, onBack, sx } = props;

  return (
    // oxlint-disable-next-line typescript/no-misused-spread -- MUI SxProps union includes functions, but spreading in sx is standard MUI pattern
    <Stack sx={{ width: "100%", flex: 1, justifyContent: "space-between", ...sx }}>
      <Box sx={{ width: "100%" }}>
        <TopLeftBackButton iconType="chevron-left" onClick={onBack} />
      </Box>

      <Box
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          gap: 6,
        }}
      >
        <Text variant="h1" sx={{ maxWidth: 320 }}>
          You’re all set!
        </Text>
        <Text variant="body1" sx={{ color: (t) => t.palette.text.secondary, maxWidth: 343 }}>
          Thanks for taking the time to learn about Clipboard Score. We’re excited to have you on
          Clipboard and we hope you have a great first shift!
        </Text>
      </Box>

      <Button
        fullWidth
        size="large"
        variant="contained"
        endIconType="chevron-right"
        sx={{ borderRadius: 999, height: 56 }}
        onClick={onConfirm}
      >
        Continue to Booking
      </Button>
    </Stack>
  );
}
